<template>
    <div>
        <div class="" style="margin-bottom: 83px;">
              <div class="TSDN-title">关于亚马逊TSPN</div>
              <div class="TSDN-content">
                TSPN(Transparency Service Provider Network)即透明计划服务商网络，是亚马逊全球开店品牌保护团队（CNBPS）与服务商之间的中长期合作计划，旨在为卖家提供更好的品牌保护与成长方向的服务和体验。
                对于加入TSPN的服务商，将能够获得亚马逊全球开店品牌保护团队提供一系列权益和资源支持，进而TSPN服务商可以帮助卖家开拓业务，提供更优质的服务。
              </div>
          </div>
    
    </div>
</template>
<script>


/**
 * Index-1 component
 */
export default {
  components: {

  },
  data(){
    return {
        
    }
  },
  methods: {
   
  }
};
</script>
<style src="./componentsIndex.css" scoped>

</style>